
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  beforeCreate() {
    var myDate = new Date();
    var hrs = myDate.getHours();
    if (hrs < 12)
      this.greeting = 'Good Morning';
    else if (hrs >= 12 && hrs <= 17)
      this.greeting = 'Good Afternoon';
    else if (hrs >= 17 && hrs <= 24)
      this.greeting = 'Good Evening';
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  data() {
    return { greeting: '' };
  },
  methods: {
    updateClass: function (e) {
      this.$root.user.class = e.target.value;
      this.$root.$update();
      localStorage.user = JSON.stringify(this.$root.user);
    }
  },
  on: {
    pageMounted: function (e, page) {
    },
    pageInit: function (e, page) {
    },
    pageBeforeIn: function (e, page) {
    },
    pageAfterIn: function (e, page) {
    },
    pageBeforeOut: function (e, page) {
    },
    pageAfterOut: function (e, page) {
    },
    pageBeforeRemove: function (e, page) {
    }
  },
  id: '074fbe8a61',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n  <div class="page" data-name="home">\r\n    <!-- <div class="page" data-name="home" style="background-image: url(\'../static/background11.png\');"> -->\r\n\r\n    <!-- Top Navbar -->\r\n    <div class="navbar navbar-transparent">\r\n      <div class="navbar-bg"></div>\r\n      <div class="navbar-inner">\r\n        <div class="left">\r\n          <a href="#" class="link icon-only panel-open" data-panel="left">\r\n            <i class="icon f7-icons if-not-md">menu</i>\r\n            <i class="icon material-icons if-md">menu</i>\r\n          </a>\r\n        </div>\r\n        <div class="title sliding">SKSIU</div>\r\n        <div class="right">\r\n          <a href="#" class="link icon-only panel-open" data-panel="right">\r\n            <i class="icon f7-icons if-not-md">menu</i>\r\n            <i class="icon material-icons if-md">menu</i>\r\n          </a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <!-- Scrollable page content-->\r\n    <div class="page-content">\r\n      <div class="block" style="margin: 10px 0px 5px 0px">\r\n        <div class="row">\r\n          <div class="col-auto col-75 medium-40">\r\n            <h3 class="text-color-blue">\r\n              ';
      r += c(ctx_1.greeting, ctx_1);
      r += '\r\n            </h3>\r\n            <h2 class="text-color-blue">';
      r += c(ctx_1.$root.user.name, ctx_1);
      r += '<br></h2>\r\n            <h4 class="text-color-blue">What do you want to study today ?</h4>\r\n          </div>\r\n          <div class="col-auto col-25 block">\r\n            <div class="home-image" style="\r\n            background-image: url(';
      r += c(ctx_1.$root.avatar, ctx_1);
      r += ');"></div>\r\n          </div>\r\n        </div>\r\n        <div class="row">\r\n          <div class="col-auto text-align-center col-100 medium-30 small-50 xsmall-50">\r\n            <div class="segmented" style="padding-bottom: 10px">\r\n              <a href="#" value="9"\r\n                class="button button-round button-small button-outline button-raised ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.$root.user.class == 9', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'button-active';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '"\r\n                @click="updateClass">Class 9</a>\r\n              <a href="#" value="10"\r\n                class="button button-round button-small button-outline button-raised ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.$root.user.class == 10', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'button-active';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '"\r\n                @click="updateClass">Class 10</a>\r\n            </div>\r\n          </div>\r\n          <div class="col-auto col-100 large-30 medium-30 small-50 xsmall-50">\r\n            <a class="button button-round button-small button-raised elevation-2" href="/analysis/"><i\r\n                class="icon f7-icons">graph_circle</i> Learning Analysis</a>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n\r\n      <div class="row no-gap text-align-center">\r\n        <div class="col-auto medium-25 col-50">\r\n          <a href="/history/">\r\n            <div class="card elevation-3 elevation-hover-6 bg-color-green">\r\n              <div class="card-content">\r\n                <div class="row">\r\n                  <div class="col-auto text-align-center col-30">\r\n                    <h3><i class="icon f7-icons">rocket_fill</i>\r\n                    </h3>\r\n                  </div>\r\n                  <div class="col-auto text-align-left col-70">\r\n                    <h4>History</h4>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </a>\r\n        </div>\r\n        <div class="col-auto medium-25 col-50">\r\n          <a href="/geography/">\r\n            <div class="card elevation-3 elevation-hover-6 bg-color-orange">\r\n              <div class="card-content">\r\n                <div class="row">\r\n                  <div class="col-auto text-align-center col-30">\r\n                    <h3><i class="icon f7-icons">rocket_fill</i>\r\n                    </h3>\r\n                  </div>\r\n                  <div class="col-auto text-align-left col-70">\r\n                    <h4>Geography</h4>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </a>\r\n        </div>\r\n        <div class="col-auto medium-25 col-50">\r\n          <a href="/economics/">\r\n            <div class="card elevation-3 elevation-hover-6 bg-color-lightblue">\r\n              <div class="card-content">\r\n                <div class="row">\r\n                  <div class="col-auto text-align-center col-30">\r\n                    <h3><i class="icon f7-icons">rocket_fill</i>\r\n                    </h3>\r\n                  </div>\r\n                  <div class="col-auto text-align-left col-70">\r\n                    <h4>Economics</h4>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </a>\r\n        </div>\r\n        <div class="col-auto medium-25 col-50">\r\n          <a href="/politicalscience/">\r\n            <div class="card elevation-3 elevation-hover-6 bg-color-red">\r\n              <div class="card-content">\r\n                <div class="row">\r\n                  <div class="col-auto text-align-center col-30">\r\n                    <h3><i class="icon f7-icons">rocket_fill</i>\r\n                    </h3>\r\n                  </div>\r\n                  <div class="col-auto text-align-left col-70">\r\n                    <h4>Political Science</h4>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </a>\r\n        </div>\r\n      </div>\r\n\r\n      <div class="block-title">Latest Videos</div>\r\n      <div data-pagination=\'{"el": ".swiper-pagination"}\' data-space-between="10" data-slides-per-view="3"\r\n        class="swiper-container swiper-init demo-swiper-multiple">\r\n        <div class="swiper-pagination"></div>\r\n        <div class="swiper-wrapper">\r\n          <div class="swiper-slide">Slide 1</div>\r\n          <div class="swiper-slide">Slide 2</div>\r\n          <div class="swiper-slide">Slide 3</div>\r\n          <div class="swiper-slide">Slide 4</div>\r\n          <div class="swiper-slide">Slide 5</div>\r\n          <div class="swiper-slide">Slide 6</div>\r\n          <div class="swiper-slide">Slide 7</div>\r\n          <div class="swiper-slide">Slide 8</div>\r\n          <div class="swiper-slide">Slide 9</div>\r\n          <div class="swiper-slide">Slide 10</div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  </div>\r\n';
      return r;
    }(this);
  },
  style: `
  .home-image {
    background-color: #ccc;
    /* background-repeat: no-repeat; */
    background-position: center;
    display: inline-block;
    height: 20vw;
    width: 20vw;
  }

  /* Swipers Demo */
  .demo-swiper {
    width: 100%;
    height: 100%;
  }

  .demo-swiper .swiper-slide,
  .demo-swiper-multiple .swiper-slide {
    font-size: 25px;
    font-weight: 300;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background: #fff;
    color: #000;
  }

  .demo-swiper-multiple .swiper-slide {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid #ccc;
    background: #fff;
  }

  .demo-swiper-multiple {
    margin: 0px 0 35px;
    font-size: 18px;
    height: 120px;
  }

  .demo-swiper-multiple.demo-swiper-multiple-auto .swiper-slide {
    width: 85%;
  }

  .demo-swiper-multiple.demo-swiper-multiple-auto .swiper-slide:nth-child(2n) {
    width: 70%;
  }

  .demo-swiper-multiple.demo-swiper-multiple-auto .swiper-slide:nth-child(3n) {
    width: 30%;
  }

  .demo-swiper-custom {
    height: 100%;
  }

  .demo-swiper-custom .swiper-container {
    background: #000;
    height: 100%;
  }

  .demo-swiper-custom .swiper-slide {
    background-size: cover;
    background-position: center;
  }

  .demo-swiper-custom .swiper-pagination .swiper-pagination-bullet {
    cursor: pointer;
    width: 10px;
    height: 10px;
    background: rgba(255, 255, 255, 0);
    opacity: 1;
    border-radius: 0;
    -webkit-transition: 200ms;
    transition: 200ms;
    position: relative;
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 0.8);
  }

  .demo-swiper-custom .swiper-pagination .swiper-pagination-bullet-active {
    z-index: 1;
    border: 1px solid #007aff;
    -webkit-transform: scale(1.4);
    transform: scale(1.4);
  }

  .demo-swiper-cube {
    width: 80%;
    height: 70%;
    top: 15%;
  }

  .demo-swiper-coverflow {
    height: 60%;
    top: 20%;
  }

  .demo-swiper-coverflow .swiper-slide {
    width: 65%;
  }

  .demo-swiper-cube .swiper-slide,
  .demo-swiper-coverflow .swiper-slide {
    background-size: cover;
    color: #fff;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden
      /* this line is added by Me */
  }

  .demo-swiper-fade .swiper-slide {
    background-size: cover;
    background-position: center;
  }

  .demo-swiper-gallery-top {
    height: 70%;
  }

  .demo-swiper-gallery-thumbs {
    margin-top: 10px;
    height: 20%;
    height: -ms-calc(30% - 20px);
    height: calc(30% - 20px);
  }

  .demo-swiper-gallery-thumbs .swiper-slide-pic {
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.35;
    -webkit-transition: 300ms;
    transition: 300ms;
  }

  .demo-swiper-gallery-thumbs .swiper-slide-thumb-active .swiper-slide-pic {
    opacity: 1;
  }

  .demo-swiper-gallery-top .swiper-slide,
  .demo-swiper-gallery-thumbs .swiper-slide-pic {
    background-size: cover;
    background-position: center;
  }

  .demo-swiper-parallax {
    height: 100%;
  }

  .demo-swiper-parallax .swiper-parallax-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 130%;
    height: 100%;
    background-size: cover;
    background-position: center;
  }

  .demo-swiper-parallax .swiper-slide {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 40px 60px;
    color: #fff;
  }

  .demo-swiper-parallax .swiper-slide-title {
    font-size: 41px;
    font-weight: 300;
  }

  .demo-swiper-parallax .swiper-slide-subtitle {
    font-size: 21px;
  }

  .demo-swiper-parallax .swiper-slide-text {
    font-size: 14px;
    max-width: 400px;
    line-height: 1.3;
  }

  .demo-swiper-lazy {
    height: 100%;
  }

  .demo-swiper-lazy .swiper-slide {
    position: relative;
  }

  .demo-swiper-lazy .swiper-slide img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
`,
  styleScoped: false
};
    